import React from 'react';
import { OFFER_ANCHOR, PRODUCT_IMAGE } from '../data/config';
type ProductImageProps = {
  className?: string;
  linkToOffer?: boolean;
};
export function ProductImage({
  className = '',
  linkToOffer = true
}: ProductImageProps) {
  const img = <img src={PRODUCT_IMAGE} alt="Combo Completo Electricistas — 4 tomos principales más 4 bonos profesionales" className={`mx-auto block h-auto w-full object-contain ${className}`} data-id="element-139" data-mp="2lk5034httt34" />;
  if (!linkToOffer) return img;
  return <a href={OFFER_ANCHOR} aria-label="Ir a la oferta especial" className="block" data-id="element-140" data-mp="27lyo1efyexx0">
      {img}
    </a>;
}